// src/components/PaymentLinkPage.jsx
import React, { useEffect } from "react";

const PaymentLinkPage = () => {
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const order_id = queryParams.get("order_id");

    console.log("order_id=====", order_id);

    if (!order_id) {
      alert("Missing order ID");
      return;
    }

    const options = {
      key: "rzp_live_iJcBvpNpCc9E6F", // Replace with your key
      // order_id: order_RBEWJLQjnaYMfP,
      order_id: order_id,
      description: "Payment via Email Link",
      handler: function (response) {
        alert(
          "Payment successful! Payment ID: " + response.razorpay_payment_id
        );
        console.log("Payment Success Response:", response);
      },
      theme: {
        color: "#0d6efd",
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  }, []);

  return (
    <div className="flex justify-center items-center h-screen">
      <p className="text-lg font-semibold">Redirecting to payment gateway...</p>
    </div>
  );
};

export default PaymentLinkPage;
